import { authenticatedFastApiAxiosInstance } from "@/lib/data/http";
import { type APIResponse, type RecentMatter } from "@/lib/types";

export const retrieveRecentMatters = () => {
  return authenticatedFastApiAxiosInstance
    .get<APIResponse<RecentMatter[]>>("/users/recent-matters")
    .then((res) => res.data);
};
